
  import { Component, Prop } from 'vue-property-decorator';
  import Vue from 'vue';
  import RefDashboardGraph from '@/components/dashboard/ReferenceDashboardGraph.vue';
  import FileCountGraph from '@/components/dashboard/FileCountGraph.vue';
  import { Get } from 'vuex-pathify';
  import MxInfoButton from '@/components/global/MxInfoButton.vue';
  import ProjectsTableSmall from '@/components/projects/ProjectsTableSmall.vue';
  import PaginatedRequest from '@/models/PaginatedRequest';
  import { IPaginatedRequest } from '@/types/services.types';

  import { IFileCountDashboardResource, IAppInfo, Permission } from '@/types/resource.types';
  
  @Component({
      name: 'ProjectDashboard',
      components: {
        RefDashboardGraph,
        MxInfoButton,
        ProjectsTableSmall,
        FileCountGraph
      }
  })
  
  
  export default class v extends Vue {

    initialProjectsRequest: IPaginatedRequest | null = null;
    /* Props
    ============================================*/
    @Prop({type: Object, required: true})
    readonly fileCountDashboard: IFileCountDashboardResource;

    @Get('appInfo')
    readonly appInfo: IAppInfo | null;
      
    showGraph: boolean = false;
    /* Data
    ============================================*/
  
    get canCreateProjects(): boolean {
        return this.$hasPermission(Permission.EditProjects);
    }
    /* Computed
    ============================================*/
    get menuCollapsed(){
      return this.$store?.state?.menuIsCollapsed;
    }
    /* Methods
    ============================================*/
    beforeMount() {
      
      let req = new PaginatedRequest();
        req.orderBy = 'created';
        req.desc = true;
        req.perPage = 5;
      this.initialProjectsRequest = { ...req };
    }

  }
  
  
  